import React from 'react';
import { connect } from 'react-redux';

import { authenticateUser } from '../../../../store/auth';
import LoginWrapper from './components/Login';

const mapStateToProps = (state) => ({
  authenticatedID: (state.auth.sub || null),
  authedUser: state.auth,
});

const mapDispatchToProps = {
  authenticateUser,
};

export default (store) => ({
  path : 'login',
  component: connect(mapStateToProps, mapDispatchToProps)(props => (
    <div className='container'>
      <div className='page-layout__viewport'>
        <LoginWrapper {...props} />
      </div>
    </div>
  )),
});



// WEBPACK FOOTER //
// ./src/routes/company/routes/Login/index.js